import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuexI18n from 'vuex-i18n'
import Toast from 'vue-easy-toast/dist/vue-easy-toast-lite.min.js'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-class-component/hooks'
import locale from './locale'
import typedKeys from './helpers/typedKeys'
import { ActionTypes } from './store/Base'
import { getToken, removeToken } from './helpers/token'
// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
import Fingerprint2 from 'fingerprintjs2'
import Bowser from 'bowser'
// @ts-ignore

// Sentry.init({
// 	dsn:
// 		'https://5e6fe4a7382bc87ed4eb1fe538560ec7@o4505507149840384.ingest.sentry.io/4505872560488448',
// 	integrations: [
// 		new Integrations.Vue({
// 			Vue,
// 			attachProps: true,
// 		}),
// 	],
// })

Vue.config.productionTip = false

const getFingerPrint = async () => {
	let fingerprint = ''
	await Fingerprint2.getPromise({
		excludes: {
			userAgent: true,
			language: true,
			sessionStorage: true,
			localStorage: true,
			indexedDb: true,
			addBehavior: true,
			openDatabase: true,
			plugins: true,
			canvas: true,
			webgl: true,
			adBlock: true,
			fonts: true,
			audio: true,
			enumerateDevices: true,
		},
	}).then(components => {
		fingerprint = Fingerprint2.x64hash128(
			components.map(c => c.value).join(''),
			31
		)
	})

	return fingerprint
}

const getDevice = () => {
	const data = Bowser.parse(window.navigator.userAgent)
	return [data.os.name, data.os.versionName, data.platform.type]
		.filter(Boolean)
		.join(',')
}

const getApiPrefix = () => {
	// console.log('API is DEV', window.location.origin.includes('dev.indigo'))
	// console.log('API is PL', window.location.origin.includes('pl.indigo'))

	if (process.env.VUE_APP_ENV === 'dev') {
		return 'dev.'
	}

	if (window.location.origin.includes('pl.indigo')) {
		return 'pl.'
	}

	return ''
}

// Configure Axios
axios.defaults.baseURL = `https://api.${getApiPrefix()}indigomental.com/v1/`

axios.interceptors.request.use(async config => {
	const token = getToken()

	config.headers['Content-Type'] =
		config.headers['Content-Type'] || 'application/json'

	config.headers.Authorization =
		config.headers?.Authorization || token ? `Token ${token}` : ''

	config.headers['Device'] = getDevice()
	config.headers['Fingerprint'] = await getFingerPrint()

	if ('No-Auth' in config.headers) {
		delete config.headers['No-Auth']
		delete config.headers['Authorization']
		delete config.headers['Device']
		delete config.headers['Fingerprint']
	}

	return config
})

axios.defaults.transformRequest = [
	(data, headers) => {
		if (headers['Content-Type'] === 'application/json') {
			return JSON.stringify(data)
		}
		return data
	},
]

axios.interceptors.response.use(undefined, error => {
	// Any status codes that falls outside the range of 2xx cause this function to trigger
	const status = error?.response?.status

	const message = error?.response?.data?.detail

	// console.log(error?.response?.data?.detail)

	// invalid token
	if (status === 401) {
		// logout user, it will redirect to signin page
		store.commit(ActionTypes['SET_IS_AUTH'], false)
		removeToken()
		window.localStorage.removeItem('userProfile')
		store.state.myProfile = null
		// Set query string to display approptiated error
		router.replace({ path: '/', query: { hard: 'true' } })
	} else if (status === 403 || status === 500 || status === 503) {
		// user has not access to any data - redirect it to 403 error page
		// any critical error occured. redirect it to 500 error page
		store.commit(ActionTypes.SET_ERROR_STATUS, status)

		store.commit(ActionTypes.SET_ERROR_MESSAGE, message)
	} else if (status === 429) {
		Vue.prototype.$toast(message || 'Limit reached', {
			className: ['btn-danger', 'notif-bottom'],
			duration: 5000,
		})
	}

	return Promise.reject(error)
})

Vue.use(VueAxios, axios)

Vue.use(BootstrapVue)
Vue.use(Toast)
Vue.use(vuexI18n.plugin, store)

// Add all locales
typedKeys(locale).forEach(lng => Vue.i18n.add(lng, locale[lng]))

if (
	window.location.origin === 'https://app.indigomental.pl' ||
	window.location.origin.includes('pl.indigo')
) {
	Vue.i18n.set('pl')
} else {
	Vue.i18n.set(
		window.localStorage.getItem('defaultLanguage') === null
			? 'en'
			: (window.localStorage.getItem('defaultLanguage') as any)
	)
}

if ((window as any).isBrowserSupport) {
	new Vue({
		router,
		store,
		render: h => h(App),
	}).$mount('#app')
}
